import { initializeApp } from 'firebase/app'

const firebaseConfig = {
  apiKey: "AIzaSyBKrEbjDC4pPAaVcquUotz3LCj99yotTIA",
  authDomain: "mirai-auth.firebaseapp.com",
  projectId: "mirai-auth",
  storageBucket: "mirai-auth.firebasestorage.app",
  messagingSenderId: "919380673955",
  appId: "1:919380673955:web:ce54bbf23ef71d77d28616"
};

const app = initializeApp(firebaseConfig)

export default app
